import React from 'react';

const NotFound = () => {
    return (
        <div className='d-flex justify-content-center'>
           <img className='w-50' src="https://i.ibb.co/L1J8hP1/404-404.jpg" alt="sorry"></img>
        </div>
    );
};

export default NotFound;